export default __webpack_public_path__ + "static/lily-cbf779a51632064c9258d7a92918e787.webp";